import { User } from "../types/type_def";

/**
 * Calls to the backend's auth and account endpoints.
 */

export async function getUser(): Promise<User> {
    return fetch("api/auth/user", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
    })
        .then(response => response.json())
        .then(data => data as User)
        .catch(() => null);
}

export interface LoginResult {
    /** The request itself failed (network or HTTP error status) */
    failed: boolean;
    success: boolean;
    /** The user must change their password */
    changePassword: boolean;
}

export async function login(username: string, password: string): Promise<LoginResult> {
    try {
        const response = await fetch("api/auth/login", {
            method: "POST",
            body: JSON.stringify({ username, password }),
            headers: { "Content-Type": "application/json" },
        });
        if (!response.ok) {
            return { failed: true, success: false, changePassword: false };
        }
        const result = await response.json();
        return { failed: false, success: !!result.success, changePassword: !!result.changePassword };
    } catch {
        return { failed: true, success: false, changePassword: false };
    }
}

export async function logout(): Promise<void> {
    await fetch("/api/auth/logout", { method: "POST", credentials: "include" });
}

/** Asks the backend to e-mail a password reset link. Returns true when accepted. */
export async function requestPasswordReset(email: string): Promise<boolean> {
    const response = await fetch("/api/account/forgotpassword", {
        method: "POST",
        body: JSON.stringify({ username: email }),
        headers: { "Content-Type": "application/json" },
    });
    return response.status === 200;
}

/** Sets a new password using the token from the reset link. Returns the HTTP status. */
export async function resetPassword(password: string, confirmPassword: string, token: string): Promise<number> {
    const response = await fetch("/api/account/resetpassword", {
        method: "POST",
        body: JSON.stringify({ password: password, confirmpassword: confirmPassword, token: token }),
        headers: { "Content-Type": "application/json" },
    });
    return response.status;
}
